<script setup>
const emit = defineEmits(['close', 'share'])

const postSharePopup = ref(true);

const close = () => emit('close');
const share = (type) => emit('share', { type });
</script>

<template>
  <VDialog
    v-model="postSharePopup"
    class="post-share__dialog"
    max-width="272px"
    @click:outside="close"
  >
    <VCard class="br16 post-share__container">
        <div class="post-share__header">
          <div>공유하기</div>
          <button class="post-share__close" @click="close"></button>
        </div>

        <div class="post-share__body">
          <div class="post-share__button-wrapper">
            <button class="post-share__button" @click="share('kakao')">
              <i class="icon-kko">카카오톡아이콘</i>
              <div>카카오톡 공유</div>
            </button>
            <button class="post-share__button" @click="share('link')">
              <i class="icon-message">붙여넣기아이콘</i>
              <div>링크공유</div>
            </button>
          </div>
        </div>
    </VCard>
  </VDialog>
</template>

<style scss>
.post-share__dialog {
  width: 100%;
}

.post-share__container {
  /* width: 100%; */
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: var(--gray-100-white, #FFF);
}

.post-share__header {
  height: 45px;
  padding: 0 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--gray-900-black, #2C2C2E);
  text-align: center;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;

  .post-share__close {
    position: absolute;
    right: 16px;
    width: 24px;
    height: 24px;
    background: url('@manseImages/x-icon.svg') center center no-repeat;
    background-size: contain;
  }
}

.post-share__body {
  /* width: 100%; */
  padding: 0 16px;

  .post-share__button-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 8px;
  }

  .post-share__button {
    width: 100px;
    aspect-ratio: 1/1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 12px;

    border-radius: 6px;
    border: 1px solid var(--Gray-300, #EBEBEB);
    background: var(--gray-100-white, #FFF);
    cursor: pointer;

    color: var(--Gray-800, #333);
    text-align: center;
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;

    &:hover {
      border-color: var(--orange-300-main, #EB4C10);
    }
    .active {
      border-color: var(--orange-300-main, #EB4C10);
    }

    .icon {
      width: 32px;
      height: 32px;
    }
  }
}
</style>